module.exports = __webpack_public_path__ + "static/media/producto4.177bcd72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/producto4.png
// module id = 254
// module chunks = 0